var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.show,"z-index":"210"}},[_c('v-progress-circular',{attrs:{"size":"64","indeterminate":""}},[_vm._v(" "+_vm._s(_vm.currentMessage)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }